import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, Box, Chip, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
var StyledSelect = styled(Select)(function (_a) {
    var theme = _a.theme;
    return ({
        minWidth: 200,
        '& .MuiSelect-multiple': {
            padding: '8px 12px',
        },
    });
});
var FilterChip = styled(Chip)(function (_a) {
    var theme = _a.theme;
    return ({
        margin: '2px',
        height: '24px',
        fontSize: '0.75rem',
    });
});
var RoomTypeFilter = function (_a) {
    var roomTypes = _a.roomTypes, selectedRoomTypes = _a.selectedRoomTypes, onRoomTypeChange = _a.onRoomTypeChange, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var handleChange = function (event) {
        var value = event.target.value;
        onRoomTypeChange(value);
    };
    var renderValue = function (selected) {
        if (selected.length === 0) {
            return 'All Room Types';
        }
        if (selected.length === 1) {
            var roomType = roomTypes.find(function (rt) { return rt.id === selected[0]; });
            return (roomType === null || roomType === void 0 ? void 0 : roomType.name) || 'Unknown Room Type';
        }
        return "".concat(selected.length, " room types");
    };
    var getSelectedRoomTypeNames = function () {
        return selectedRoomTypes.map(function (id) {
            var roomType = roomTypes.find(function (rt) { return rt.id === id; });
            return (roomType === null || roomType === void 0 ? void 0 : roomType.name) || "Room Type ".concat(id);
        });
    };
    if (loading) {
        return (_jsxs(FormControl, { fullWidth: true, disabled: true, children: [_jsx(InputLabel, { children: "Loading Room Types..." }), _jsx(Select, { value: [], renderValue: function () { return (_jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [_jsx(CircularProgress, { size: 16 }), "Loading..."] })); }, children: _jsx(MenuItem, { disabled: true, children: _jsx(CircularProgress, { size: 20 }) }) })] }));
    }
    return (_jsxs(Box, { children: [_jsxs(FormControl, { fullWidth: true, disabled: disabled, children: [_jsx(InputLabel, { children: "Rooms filter" }), _jsxs(Select, { multiple: true, value: selectedRoomTypes, onChange: handleChange, renderValue: renderValue, sx: {
                            minWidth: 200,
                            '& .MuiSelect-multiple': {
                                padding: '8px 12px',
                            },
                        }, MenuProps: {
                            PaperProps: {
                                style: {
                                    maxHeight: 300,
                                    width: 250,
                                },
                            },
                        }, children: [_jsxs(MenuItem, { value: "", children: [_jsx(Checkbox, { checked: selectedRoomTypes.length === 0, indeterminate: selectedRoomTypes.length > 0 && selectedRoomTypes.length < roomTypes.length, onChange: function () {
                                            if (selectedRoomTypes.length === 0 || selectedRoomTypes.length === roomTypes.length) {
                                                onRoomTypeChange([]);
                                            }
                                            else {
                                                onRoomTypeChange(roomTypes.map(function (rt) { return rt.id; }));
                                            }
                                        }, size: "small" }), _jsx(ListItemText, { primary: "All Room Types", primaryTypographyProps: { fontWeight: 'bold' } })] }), roomTypes.map(function (roomType) { return (_jsxs(MenuItem, { value: roomType.id, children: [_jsx(Checkbox, { checked: selectedRoomTypes.includes(roomType.id), size: "small", color: "primary" }), _jsx(ListItemText, { primary: roomType.name, secondary: roomType.property_name, primaryTypographyProps: { fontSize: '0.875rem' }, secondaryTypographyProps: { fontSize: '0.75rem' } })] }, roomType.id)); }), roomTypes.length === 0 && (_jsx(MenuItem, { disabled: true, children: _jsx(ListItemText, { primary: "No room types available" }) }))] })] }), selectedRoomTypes.length > 0 && (_jsx(Box, { sx: { mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }, children: getSelectedRoomTypeNames().map(function (name, index) { return (_jsx(FilterChip, { label: name, color: "primary", size: "small", onDelete: function () {
                        var newSelected = selectedRoomTypes.filter(function (id) { return id !== selectedRoomTypes[index]; });
                        onRoomTypeChange(newSelected);
                    } }, selectedRoomTypes[index])); }) }))] }));
};
export default RoomTypeFilter;
